var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tree',_vm._g(_vm._b({directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"memberTree",attrs:{"props":_vm.props,"data":_vm.data,"node-key":"value","filter-node-method":_vm.filterNode}},'el-tree',_vm.attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }